<template>
  <span>
    Subscription to {{ eventLog.plan }} plan cancelled
  </span>
</template>
<script>
export default {
  name: 'recentActivityTableDescriptionSubscriptionCancelled',
  props: {
    eventLog: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
